import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormArray, FormBuilder, Validators} from '@angular/forms';
import {WizardValidators} from '../../wizard-validators';
import {WizardFormEventsService} from '../wizard-form-events.service';
import {takeUntil} from 'rxjs/operators';

@Injectable()
export class OrganizationCommonService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        /**
         * Форма собственности
         */
        business_structure_id: ['', WizardValidators.required()],

        /**
         * Полное наименование
         */
        title: ['', [
            WizardValidators.required('Полное наименование организации'),
            WizardValidators.withoutSymbols('наименовании юридического лица'),
        ]],

        /**
         * Сокращенное наименование
         */
        short_title: ['', [
            WizardValidators.required('Сокращенное наименование организации'),
            WizardValidators.withoutSymbols('наименовании юридического лица'),
        ]],

        /**
         * Руководитель организации
         */
        owner: ['', [
            WizardValidators.required('Руководитель организации'),
            WizardValidators.withoutSymbols('имени руководителя'),
        ]],

        /**
         * Должность руководителя
         */
        owner_job: ['',  [
            WizardValidators.required('Должность руководителя организации'),
            WizardValidators.withoutSymbols('должности руководителя'),
        ]],

        /**
         * Должность в родительном падеже
         */
        owner_job_genitive: ['',  [
            WizardValidators.required('Должность руководителя организации'),
            WizardValidators.withoutSymbols('должности руководителя'),
        ]],

        /**
         * Должность в дательном падеже
         */
        owner_job_dative: ['',  [
            WizardValidators.required('Должность руководителя организации'),
            WizardValidators.withoutSymbols('должности руководителя'),
        ]],
    });

    constructor(
        private fb: FormBuilder,
        private wizardFormEventsService: WizardFormEventsService,
    ) {
        super();
    }

    init() {
        this.form.get('owner').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((name) => {
            this.wizardFormEventsService.setOrganizationOwnerName(name);
        });

        this.form.get('owner_job').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((job) => {
            this.wizardFormEventsService.setOrganizationOwnerJob(job);
        });

        this.form.get('business_structure_id').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((id) => {
            this.wizardFormEventsService.setOrganizationBusinessStructureId(+id);
        });

        this.form.get('title').valueChanges.pipe(
            takeUntil(this.destroyed$)
        ).subscribe((title) => {
            this.wizardFormEventsService.setOrganizationTitle(title);
        });

        this.form.get('owner').updateValueAndValidity();
        this.form.get('owner_job').updateValueAndValidity();
        this.form.get('business_structure_id').updateValueAndValidity();
        this.form.get('title').updateValueAndValidity();
    }

    restoreValidators() {

    }
}
